import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-payment-detail-comment',
  templateUrl: './payment-detail-comment.component.html',
  styleUrls: ['./payment-detail-comment.component.scss'],
  standalone: false
})
export class PaymentDetailCommentComponent {
  @Input() public comment = '';
  @Input() public editMode = false;
  @Output() public commentChange: EventEmitter<string> = new EventEmitter();

  public onChange(): void {
    this.commentChange.emit(this.comment);
  }
}
